import BagIcon from "../assets/bag.svg";
import BeltIcon from "../assets/belt.svg";
import BootsMenIcon from "../assets/mens-boots.svg";
import BootsWomenIcon from "../assets/womens-boots.svg";
import Box from "./Box";
import BraIcon from "../assets/bra.svg";
import DressIcon from "../assets/dress.svg";
import FleeceIcon from "../assets/fleece.svg";
import GiletIcon from "../assets/gilet.svg";
import HalfTightsIcon from "../assets/half-tights.svg";
import HoldallIcon from "../assets/holdall.svg";
import InsulatedJacketIcon from "../assets/insulated-jacket.svg";
import JacketIcon from "../assets/jacket.svg";
import JeansIcon from "../assets/jeans.svg";
import JumpsuitIcon from "../assets/jumpsuit.svg";
import KidsShoesIcon from "../assets/kids-shoes.svg";
import KnitwearIcon from "../assets/knitwear.svg";
import OtherIcon from "../assets/other.svg";
import PantsMenIcon from "../assets/pants-men.svg";
import PoloShirtIcon from "../assets/polo-shirt.svg";
import React from "react";
import RugbyShirtIcon from "../assets/rugby-shirt.svg";
import ShirtIcon from "../assets/shirt.svg";
import ShoeIcon from "../assets/shoe.svg";
import ShortsIcon from "../assets/shorts.svg";
import SkirtIcon from "../assets/skirt.svg";
import SocksIcon from "../assets/socks.svg";
import SwimwearMenIcon from "../assets/swimwear-men.svg";
import SwimwearWomenIcon from "../assets/swimwear-women.svg";
import Text from "./Text";
import TopIcon from "../assets/top.svg";
import TrousersIcon from "../assets/trousers.svg";
import TshirtIcon from "../assets/tshirt.svg";
import WaterproofsIcon from "../assets/waterproofs.svg";
import WelliesIcon from "../assets/wellies.svg";
import WetsuitIcon from "../assets/wetsuit.svg";
import NightwearIcon from "../assets/nightwear.svg";
import TrainersIcon from "../assets/trainers.svg";
import SandalsIcon from "../assets/sandals.svg";
import HatIcon from "../assets/hat.svg";
import HoodieIcon from "../assets/Hoodie.svg";
import LeggingsIcon from "../assets/Leggings.svg";
import RobeIcon from "../assets/robe.svg";

function getIcon(iconName) {
  let icon;
  switch (iconName) {
    case "Jacket":
      icon = JacketIcon;
      break;
    case "Shirt":
      icon = ShirtIcon;
      break;
    case "Top":
      icon = TopIcon;
      break;
    case "Skirt":
      icon = SkirtIcon;
      break;
    case "Dress":
      icon = DressIcon;
      break;
    case "Jumpsuit":
      icon = JumpsuitIcon;
      break;
    case "Jeans":
      icon = JeansIcon;
      break;
    case "Knitwear":
      icon = KnitwearIcon;
      break;
    case "Bag":
      icon = BagIcon;
      break;
    case "Bras":
      icon = BraIcon;
      break;
    case "Fleeces":
      icon = FleeceIcon;
      break;
    case "Half tights":
      icon = HalfTightsIcon;
      break;
    case "Holdall":
      icon = HoldallIcon;
      break;
    case "Insulated jacket":
      icon = InsulatedJacketIcon;
      break;
    case "Pants - men":
      icon = PantsMenIcon;
      break;
    case "Shorts":
      icon = ShortsIcon;
      break;
    case "Socks":
      icon = SocksIcon;
      break;
    case "Swimwear - men":
      icon = SwimwearMenIcon;
      break;
    case "Swimwear - women":
      icon = SwimwearWomenIcon;
      break;
    case "Tshirt":
      icon = TshirtIcon;
      break;
    case "Waterproofs":
      icon = WaterproofsIcon;
      break;
    case "Wetsuit":
      icon = WetsuitIcon;
      break;
    case "Gilet":
      icon = GiletIcon;
      break;
    case "Boots - women":
      icon = BootsWomenIcon;
      break;
    case "Boots - men":
      icon = BootsMenIcon;
      break;
    case "Wellies":
      icon = WelliesIcon;
      break;
    case "Rugby shirt":
      icon = RugbyShirtIcon;
      break;
    case "Polo shirt":
      icon = PoloShirtIcon;
      break;
    case "Belt":
      icon = BeltIcon;
      break;
    case "Shoes":
      icon = ShoeIcon;
      break;
    case "Trousers":
      icon = TrousersIcon;
      break;
    case "Kids shoes":
      icon = KidsShoesIcon;
      break;
    case "Nightwear":
      icon = NightwearIcon;
      break;
    case "Trainers":
      icon = TrainersIcon;
      break;
    case "Sandals":
      icon = SandalsIcon;
      break;
    case "Hat":
      icon = HatIcon;
      break;
    case "Hoodie":
      icon = HoodieIcon;
      break;
    case "Leggings":
      icon = LeggingsIcon;
      break;
    case "Robe":
      icon = RobeIcon;
      break;
    case "Other":
      icon = OtherIcon;
      break;
    default:
      icon = OtherIcon;
      break;
  }
  return icon;
}

function GarmentWithIcon({ name, icon }) {
  const Icon = getIcon(icon);

  return (
    <>
      <Box pr={22} display={["none", null, "initial", null]}>
        <Icon />
      </Box>

      <Text fontWeight={700} fontFamily="bold" fontSize={[14, 16, 22, 22]}>
        {name}
      </Text>
    </>
  );
}

export default GarmentWithIcon;
